<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner :animation-duration="1000" :size="60" color="#ff1d5e" class="mx-auto" />
    </div>
    <div v-else class="vx-row">
      <vx-card>
        <vs-table 
          max-items="10" 
          search 
          pagination 
          :description="false" 
          :data="messageLogList || []"
        >
<template slot="header">
  <div class="list-heading mb-2">
    {{ $t("admin.label.MessageLog") }}
  </div>
  <div class="mt-1 order-1">
  <div class="filter-bar flex flex-wrap items-center gap-4 mb-4 px-2 py-2 bg-gray-50 rounded">
    <div class="flex-1 min-w-[90px] cursor-pointer">
      <v-select
        label="text"
        v-model="selectedMessageType"
        placeholder="Select Message Type"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
        :options="searchMessageType"
        :reduce="option => option.value" 
        @input="fetchFilteredLogs"
        class="w-full"
      />
    </div>
    <div class="flex-1 min-w-[90px] cursor-pointer">
      <v-select
        label="text"
        v-model="selectedStatus"
        placeholder="Select Status"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
        :options="searchStatusType"
        :reduce="option => option.value" 
        @input="fetchFilteredLogs"
        class="w-full"
      />
    </div>
  </div>
  </div>
  <div class="mb-1 order-1">
                      <div class="flex items-center mb-3 dateFilter-bar">
                <div class="p-1 mt-2 flex items-center text-lg font-medium w-full date-field">
                  <datepicker
                    name="start-date"
                    :placeholder="$t('customers.label.start_date')"
                    v-model="orderSearch.startDate"
                  ></datepicker>
                </div>
                <div class="p-1 mt-2 flex items-center text-lg font-medium w-full date-field">
                  <datepicker
                    name="end-date"
                    class="end-date-calender"
                    :placeholder="$t('customers.label.end_date')"
                    v-model="orderSearch.endDate"
                  ></datepicker>
                </div>
                <div class="p-1 flex items-center text-lg font-medium w-full">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    class="mt-2 search-button"
                    icon="icon-search"
                    @click="searchOrderList"
                  ></vs-button>
                </div>
              </div>
                    </div>
</template>
          <template slot="thead">
            <vs-th>{{ $t("admin.label.MessageTo") }}</vs-th>
            <vs-th>{{ $t("admin.label.MessageFrom") }}</vs-th>
            <vs-th>{{ $t("admin.label.Subject") }}</vs-th>
            <vs-th>{{ $t("admin.label.MessageType") }}</vs-th>
            <vs-th>{{ $t("Message Sent Date") }}</vs-th>
            <vs-th>{{ $t("admin.label.Template") }}</vs-th>
            <vs-th>{{ $t("admin.label.status") }}</vs-th>
            <vs-th class="tHeadCenter">
              {{ $t("admin.label.Actions") }}
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="messageLogList" v-for="(message, index) in data">
              <vs-td>{{ message.messageTo }}</vs-td>
              <vs-td>{{ message.messageFrom }}</vs-td>
              <vs-td>{{ message.subject }}</vs-td>
              <vs-td>{{ message.messageType }}</vs-td>
              <vs-td>{{ getDate(message.messageSentdate) }}</vs-td>
              <vs-td>{{ message.template }}</vs-td>
              <vs-td>{{ message.status }}</vs-td>
              <vs-td>
                <div class="text-center">
                  <feather-icon title="View" icon="EyeIcon" @click="openPopup(message.body)"
                    class="text-primary icon_row" svgClasses="w-5 h-5 stroke-current text-primary" />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-popup :title="$t('admin.label.ViewMessageLog')" :active.sync="filterPopup" class="popup-close">
          <template v-if="isParsedJson">
            <div class="vx-row" v-for="(value, key) in parsedData" :key="key">
              <div class="vx-col w-1/2 font-bold">
                {{ stripTags(key) }}:
              </div>
              <div class="vx-col w-1/2">
                {{ value }}
              </div>
            </div>
          </template>

          <template v-else>
            <div v-html="parsedData"></div>
          </template>
        </vs-popup>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
export default {
  data() {
    return {
      loading: false,
      filterPopup: false,
      parsedData: null,
      isParsedJson: false,
      selectedMessageType: null,
      selectedStatus: null,
      searchMessageType: [
        { text: "Message", value: "M" },
        { text: "Email", value: "E" },
      ],
      searchStatusType: [
        { text: "Success", value: "Y" },
        { text: "Failed", value: "N" },
      ],
      orderSearch: {
        startDate:moment().subtract(7,'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
    };
  },

  components: { AtomSpinner, "v-select": vSelect, Datepicker, },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      messageLogList: (state) => state.admin.messageLogList,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    stripTags(text) {
      return text.replace(/<([^>]+)>/g, '$1');
    },
    async getMessageLogMethod() {
      try {
        await this.$store.dispatch("admin/getMessageLogAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchFilteredLogs() {
  try {
    const payload = {};

    if (this.selectedMessageType) {
      payload.messageType = this.selectedMessageType;
    }
    if (this.selectedStatus) {
      payload.status = this.selectedStatus; // Y or N
    }
    if (payload.messageType || payload.status) {
      await this.$store.dispatch("admin/getMessageLogSearchAction", payload);
    } else {
      await this.getMessageLogMethod();
    }
  } catch (error) {
    console.error("Error fetching filtered logs:", error);
  }
},
async searchOrderList() {
      this.loading = true;
  try {
    const payload = {
      startDate: this.orderSearch.startDate 
        ? moment(this.orderSearch.startDate).format("YYYY-MM-DD")
        : null,
      endDate: this.orderSearch.endDate
        ? moment(this.orderSearch.endDate).format("YYYY-MM-DD")
        : null,
      messageType: this.selectedMessageType || null,
      status: this.selectedStatus || null,
    };

    console.log("Payload for message log search:", payload);

    if (payload.startDate && payload.endDate && payload.startDate > payload.endDate) {
      this.$toasted.error("Start date cannot be greater than end date", { duration: 2000 });
      this.loading = false;
      return;
    }

    await this.$store.dispatch("admin/getMessageDateFilterAction", payload);
  } catch (error) {
    this.$toasted.error(error.message || "Failed to fetch message logs", { duration: 2000 });
  } finally {
    this.loading = false;
  }
    },
    openPopup(data) {
      try {
        const obj = JSON.parse(data);
        this.parsedData = obj;
        this.isParsedJson = true;
      } catch (e) {
        this.parsedData = data;
        this.isParsedJson = false;
      }
      this.filterPopup = true;
    },
  },
  async mounted() {
    await this.searchOrderList();
    // await this.getMessageLogMethod();
    // await this.fetchFilteredLogs();
  },
};
</script>

<style lang="scss" scoped>
// .vs-table--search {
// <style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}

.text-status {
  margin-bottom: 2px;
  margin-right: 15px;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
  // background: #f9fafb;
  border-radius: 0.5rem;
}

.filter-bar > div {
  min-width: 130px;
  flex: 1 1 200px;
}
.end-date-calender .vdp-datepicker__calendar {
  right: 0;
}
.dateFilter-bar {
  margin-right: -100px;
}
</style>
